import React, { useState } from 'react'
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow
} from '@react-google-maps/api'
import * as ArchiveStyles from './Archive.module.scss'
// eslint-disable-next-line node/no-extraneous-import
import { useQuery } from '@apollo/client'
import type {
  IPinsQueryData,
  IPinsQueryVariable,
  IPin
} from '../../graphql/queries/PinsQuery'
import PinsQuery from '../../graphql/queries/PinsQuery'

const containerStyle = {
  width: '100%',
  height: '100%'
}

interface MapProps {
  countyLatLon: string
  databaseId: number
  category: string
  zoom: number
}

const icon = {
  path: 'M39 20a19 19 0 1 1-38 0 19 19 0 1 1 38 0z',
  fillColor: '#d60b52',
  fillOpacity: 0.4,
  scale: 0.4,
  strokeColor: '#d60b52',
  strokeOpacity: 1,
  strokeWeight: 2
}

const Map = ({ countyLatLon, databaseId, category, zoom }: MapProps) => {
  const [activeLocation, setActiveLocation] = useState<IPin | null>(null)

  const { data, loading, error } = useQuery<IPinsQueryData, IPinsQueryVariable>(
    PinsQuery,
    {
      variables: { databaseId: databaseId.toString() }
    }
  )

  if (!countyLatLon) return null

  const center = {
    lat: Number(countyLatLon.split(',')[0]),
    lng: Number(countyLatLon.split(',')[1])
  }

  const pinClick = (pin: IPin) => {
    setActiveLocation(pin)
  }

  if (loading) return <div className={ArchiveStyles.Map}></div>

  if (error || !data) return null

  return (
    <div className={ArchiveStyles.Map}>
      <LoadScript googleMapsApiKey="AIzaSyDySDPxJPrZ-9x46IaAcvbBXTSyhY7bAxc">
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={zoom}
        >
          <>
            {data.category?.pins &&
              data.category?.pins.slice(0, 400).map((pin, index: number) => {
                const position = pin.latlon.split(',')
                return (
                  <Marker
                    icon={icon}
                    position={{
                      lat: Number(position[0]),
                      lng: Number(position[1])
                    }}
                    onClick={() => pinClick(pin)}
                    key={index}
                  />
                )
              })}
            {activeLocation && (
              <InfoWindow
                position={{
                  lat: Number(activeLocation.latlon.split(',')[0]),
                  lng: Number(activeLocation.latlon.split(',')[1])
                }}
                onCloseClick={() => setActiveLocation(null)}
              >
                <div className={ArchiveStyles.Info}>
                  <h3
                    dangerouslySetInnerHTML={{
                      __html: activeLocation.title ?? ''
                    }}
                  />
                  <div className={ArchiveStyles.MapImage}>
                    <img
                      src={activeLocation.image}
                      alt={activeLocation.title}
                    />
                  </div>
                  <a href={activeLocation.uri}>
                    {category === 'school-reviews'
                      ? `Read the review`
                      : `View the article`}
                  </a>
                </div>
              </InfoWindow>
            )}
          </>
        </GoogleMap>
      </LoadScript>
    </div>
  )
}

export default Map
